/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getCourse = /* GraphQL */ `query GetCourse($id: ID!) {
  getCourse(id: $id) {
    id
    title
    productCode
    description
    thumbnail
    duration
    readable
    tags {
      items {
        id
        courseID
        tagID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    clips {
      items {
        id
        title
        type
        url
        cover
        content
        order
        duration
        courseId
        timestamp
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    likes {
      courseId
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        release
        timestamp
        createdAt
        updatedAt
        __typename
      }
      count
      timestamp
      createdAt
      updatedAt
      __typename
    }
    release
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetCourseQueryVariables, APITypes.GetCourseQuery>;
export const listCourses = /* GraphQL */ `query ListCourses(
  $id: ID
  $filter: ModelCourseFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCourses(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      title
      productCode
      description
      thumbnail
      duration
      readable
      tags {
        nextToken
        __typename
      }
      clips {
        nextToken
        __typename
      }
      likes {
        courseId
        count
        timestamp
        createdAt
        updatedAt
        __typename
      }
      release
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCoursesQueryVariables,
  APITypes.ListCoursesQuery
>;
export const searchCourses = /* GraphQL */ `query SearchCourses(
  $filter: SearchableCourseFilterInput
  $sort: [SearchableCourseSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableCourseAggregationInput]
) {
  searchCourses(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      title
      productCode
      description
      thumbnail
      duration
      readable
      tags {
        nextToken
        __typename
      }
      clips {
        nextToken
        __typename
      }
      likes {
        courseId
        count
        timestamp
        createdAt
        updatedAt
        __typename
      }
      release
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchCoursesQueryVariables,
  APITypes.SearchCoursesQuery
>;
export const getCourseAccessSchedule = /* GraphQL */ `query GetCourseAccessSchedule($id: ID!) {
  getCourseAccessSchedule(id: $id) {
    id
    courseId
    companyId
    target
    mode
    done
    ttl
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCourseAccessScheduleQueryVariables,
  APITypes.GetCourseAccessScheduleQuery
>;
export const listCourseAccessSchedules = /* GraphQL */ `query ListCourseAccessSchedules(
  $id: ID
  $filter: ModelCourseAccessScheduleFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCourseAccessSchedules(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      courseId
      companyId
      target
      mode
      done
      ttl
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCourseAccessSchedulesQueryVariables,
  APITypes.ListCourseAccessSchedulesQuery
>;
export const listScheduleByStatus = /* GraphQL */ `query ListScheduleByStatus(
  $done: Int!
  $target: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCourseAccessScheduleFilterInput
  $limit: Int
  $nextToken: String
) {
  listScheduleByStatus(
    done: $done
    target: $target
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      courseId
      companyId
      target
      mode
      done
      ttl
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListScheduleByStatusQueryVariables,
  APITypes.ListScheduleByStatusQuery
>;
export const getUserEnableSchedule = /* GraphQL */ `query GetUserEnableSchedule($id: ID!) {
  getUserEnableSchedule(id: $id) {
    id
    username
    target
    action
    done
    ttl
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserEnableScheduleQueryVariables,
  APITypes.GetUserEnableScheduleQuery
>;
export const listUserEnableSchedules = /* GraphQL */ `query ListUserEnableSchedules(
  $id: ID
  $filter: ModelUserEnableScheduleFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUserEnableSchedules(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      username
      target
      action
      done
      ttl
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserEnableSchedulesQueryVariables,
  APITypes.ListUserEnableSchedulesQuery
>;
export const listUserScheduleByStatus = /* GraphQL */ `query ListUserScheduleByStatus(
  $done: Int!
  $target: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserEnableScheduleFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserScheduleByStatus(
    done: $done
    target: $target
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      username
      target
      action
      done
      ttl
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserScheduleByStatusQueryVariables,
  APITypes.ListUserScheduleByStatusQuery
>;
export const getRegistDemoUser = /* GraphQL */ `query GetRegistDemoUser($id: ID!) {
  getRegistDemoUser(id: $id) {
    id
    username
    password
    group
    company
    email
    approve
    ttl
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRegistDemoUserQueryVariables,
  APITypes.GetRegistDemoUserQuery
>;
export const listRegistDemoUsers = /* GraphQL */ `query ListRegistDemoUsers(
  $id: ID
  $filter: ModelRegistDemoUserFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listRegistDemoUsers(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      username
      password
      group
      company
      email
      approve
      ttl
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRegistDemoUsersQueryVariables,
  APITypes.ListRegistDemoUsersQuery
>;
export const listRegistDemoUserByApprove = /* GraphQL */ `query ListRegistDemoUserByApprove(
  $approve: Int!
  $timestamp: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRegistDemoUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listRegistDemoUserByApprove(
    approve: $approve
    timestamp: $timestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      username
      password
      group
      company
      email
      approve
      ttl
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRegistDemoUserByApproveQueryVariables,
  APITypes.ListRegistDemoUserByApproveQuery
>;
export const getClip = /* GraphQL */ `query GetClip($id: ID!) {
  getClip(id: $id) {
    id
    title
    type
    url
    cover
    content
    order
    duration
    plays {
      clipId
      clip {
        id
        title
        type
        url
        cover
        content
        order
        duration
        courseId
        timestamp
        createdAt
        updatedAt
        __typename
      }
      count
      timestamp
      createdAt
      updatedAt
      __typename
    }
    captions {
      items {
        id
        lang
        label
        url
        default
        clipId
        timestamp
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    courseId
    course {
      id
      title
      productCode
      description
      thumbnail
      duration
      readable
      tags {
        nextToken
        __typename
      }
      clips {
        nextToken
        __typename
      }
      likes {
        courseId
        count
        timestamp
        createdAt
        updatedAt
        __typename
      }
      release
      timestamp
      createdAt
      updatedAt
      __typename
    }
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetClipQueryVariables, APITypes.GetClipQuery>;
export const listClips = /* GraphQL */ `query ListClips(
  $id: ID
  $filter: ModelClipFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listClips(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      title
      type
      url
      cover
      content
      order
      duration
      plays {
        clipId
        count
        timestamp
        createdAt
        updatedAt
        __typename
      }
      captions {
        nextToken
        __typename
      }
      courseId
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        release
        timestamp
        createdAt
        updatedAt
        __typename
      }
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListClipsQueryVariables, APITypes.ListClipsQuery>;
export const listClipsByCourse = /* GraphQL */ `query ListClipsByCourse(
  $courseId: ID!
  $order: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelClipFilterInput
  $limit: Int
  $nextToken: String
) {
  listClipsByCourse(
    courseId: $courseId
    order: $order
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      title
      type
      url
      cover
      content
      order
      duration
      plays {
        clipId
        count
        timestamp
        createdAt
        updatedAt
        __typename
      }
      captions {
        nextToken
        __typename
      }
      courseId
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        release
        timestamp
        createdAt
        updatedAt
        __typename
      }
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClipsByCourseQueryVariables,
  APITypes.ListClipsByCourseQuery
>;
export const getClipCaption = /* GraphQL */ `query GetClipCaption($id: ID!) {
  getClipCaption(id: $id) {
    id
    lang
    label
    url
    default
    clipId
    clip {
      id
      title
      type
      url
      cover
      content
      order
      duration
      plays {
        clipId
        count
        timestamp
        createdAt
        updatedAt
        __typename
      }
      captions {
        nextToken
        __typename
      }
      courseId
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        release
        timestamp
        createdAt
        updatedAt
        __typename
      }
      timestamp
      createdAt
      updatedAt
      __typename
    }
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetClipCaptionQueryVariables,
  APITypes.GetClipCaptionQuery
>;
export const listClipCaptions = /* GraphQL */ `query ListClipCaptions(
  $id: ID
  $filter: ModelClipCaptionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listClipCaptions(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      lang
      label
      url
      default
      clipId
      clip {
        id
        title
        type
        url
        cover
        content
        order
        duration
        courseId
        timestamp
        createdAt
        updatedAt
        __typename
      }
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClipCaptionsQueryVariables,
  APITypes.ListClipCaptionsQuery
>;
export const getTag = /* GraphQL */ `query GetTag($id: ID!) {
  getTag(id: $id) {
    id
    label
    type
    order
    courses {
      items {
        id
        courseID
        tagID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTagQueryVariables, APITypes.GetTagQuery>;
export const listTags = /* GraphQL */ `query ListTags(
  $id: ID
  $filter: ModelTagFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTags(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      label
      type
      order
      courses {
        nextToken
        __typename
      }
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTagsQueryVariables, APITypes.ListTagsQuery>;
export const listTagsByType = /* GraphQL */ `query ListTagsByType(
  $type: String!
  $order: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTagFilterInput
  $limit: Int
  $nextToken: String
) {
  listTagsByType(
    type: $type
    order: $order
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      label
      type
      order
      courses {
        nextToken
        __typename
      }
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTagsByTypeQueryVariables,
  APITypes.ListTagsByTypeQuery
>;
export const searchTags = /* GraphQL */ `query SearchTags(
  $filter: SearchableTagFilterInput
  $sort: [SearchableTagSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableTagAggregationInput]
) {
  searchTags(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      label
      type
      order
      courses {
        nextToken
        __typename
      }
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchTagsQueryVariables,
  APITypes.SearchTagsQuery
>;
export const getCompany = /* GraphQL */ `query GetCompany($id: ID!) {
  getCompany(id: $id) {
    id
    name
    logos {
      device
      content
      __typename
    }
    custom
    recommendTitle
    secret
    authtype
    referers
    description
    adPermission
    cnbcPlan
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCompanyQueryVariables,
  APITypes.GetCompanyQuery
>;
export const listCompanies = /* GraphQL */ `query ListCompanies(
  $id: ID
  $filter: ModelCompanyFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCompanies(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      logos {
        device
        content
        __typename
      }
      custom
      recommendTitle
      secret
      authtype
      referers
      description
      adPermission
      cnbcPlan
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompaniesQueryVariables,
  APITypes.ListCompaniesQuery
>;
export const getRecommendCourse = /* GraphQL */ `query GetRecommendCourse($id: ID!) {
  getRecommendCourse(id: $id) {
    id
    order
    companyId
    keyword
    courseId
    course {
      id
      title
      productCode
      description
      thumbnail
      duration
      readable
      tags {
        nextToken
        __typename
      }
      clips {
        nextToken
        __typename
      }
      likes {
        courseId
        count
        timestamp
        createdAt
        updatedAt
        __typename
      }
      release
      timestamp
      createdAt
      updatedAt
      __typename
    }
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRecommendCourseQueryVariables,
  APITypes.GetRecommendCourseQuery
>;
export const listRecommendCourses = /* GraphQL */ `query ListRecommendCourses(
  $id: ID
  $filter: ModelRecommendCourseFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listRecommendCourses(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      order
      companyId
      keyword
      courseId
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        release
        timestamp
        createdAt
        updatedAt
        __typename
      }
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecommendCoursesQueryVariables,
  APITypes.ListRecommendCoursesQuery
>;
export const listRecommendCourseByCompany = /* GraphQL */ `query ListRecommendCourseByCompany(
  $companyId: String!
  $keyword: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRecommendCourseFilterInput
  $limit: Int
  $nextToken: String
) {
  listRecommendCourseByCompany(
    companyId: $companyId
    keyword: $keyword
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      order
      companyId
      keyword
      courseId
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        release
        timestamp
        createdAt
        updatedAt
        __typename
      }
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecommendCourseByCompanyQueryVariables,
  APITypes.ListRecommendCourseByCompanyQuery
>;
export const getDisplayTopRecommend = /* GraphQL */ `query GetDisplayTopRecommend($id: ID!) {
  getDisplayTopRecommend(id: $id) {
    id
    title
    order
    displayFrom
    displayTo
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDisplayTopRecommendQueryVariables,
  APITypes.GetDisplayTopRecommendQuery
>;
export const listDisplayTopRecommends = /* GraphQL */ `query ListDisplayTopRecommends(
  $id: ID
  $filter: ModelDisplayTopRecommendFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDisplayTopRecommends(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      title
      order
      displayFrom
      displayTo
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDisplayTopRecommendsQueryVariables,
  APITypes.ListDisplayTopRecommendsQuery
>;
export const getCustomArea = /* GraphQL */ `query GetCustomArea($id: ID!) {
  getCustomArea(id: $id) {
    id
    companyId
    type
    device
    content
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCustomAreaQueryVariables,
  APITypes.GetCustomAreaQuery
>;
export const listCustomAreas = /* GraphQL */ `query ListCustomAreas(
  $id: ID
  $filter: ModelCustomAreaFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCustomAreas(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      companyId
      type
      device
      content
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCustomAreasQueryVariables,
  APITypes.ListCustomAreasQuery
>;
export const listCustomAreaByCompany = /* GraphQL */ `query ListCustomAreaByCompany(
  $companyId: String!
  $timestamp: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCustomAreaFilterInput
  $limit: Int
  $nextToken: String
) {
  listCustomAreaByCompany(
    companyId: $companyId
    timestamp: $timestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      type
      device
      content
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCustomAreaByCompanyQueryVariables,
  APITypes.ListCustomAreaByCompanyQuery
>;
export const getNews = /* GraphQL */ `query GetNews($id: ID!) {
  getNews(id: $id) {
    id
    companyId
    title
    content
    type
    displayFrom
    displayTo
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetNewsQueryVariables, APITypes.GetNewsQuery>;
export const listNews = /* GraphQL */ `query ListNews(
  $id: ID
  $filter: ModelNewsFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listNews(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      companyId
      title
      content
      type
      displayFrom
      displayTo
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListNewsQueryVariables, APITypes.ListNewsQuery>;
export const listNewsByCompany = /* GraphQL */ `query ListNewsByCompany(
  $companyId: String!
  $displayFrom: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNewsFilterInput
  $limit: Int
  $nextToken: String
) {
  listNewsByCompany(
    companyId: $companyId
    displayFrom: $displayFrom
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      title
      content
      type
      displayFrom
      displayTo
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNewsByCompanyQueryVariables,
  APITypes.ListNewsByCompanyQuery
>;
export const getSearchKwd = /* GraphQL */ `query GetSearchKwd($id: ID!) {
  getSearchKwd(id: $id) {
    id
    companyId
    keyword
    userName
    userTag
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSearchKwdQueryVariables,
  APITypes.GetSearchKwdQuery
>;
export const listSearchKwds = /* GraphQL */ `query ListSearchKwds(
  $id: ID
  $filter: ModelSearchKwdFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSearchKwds(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      companyId
      keyword
      userName
      userTag
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSearchKwdsQueryVariables,
  APITypes.ListSearchKwdsQuery
>;
export const getSignInLog = /* GraphQL */ `query GetSignInLog($id: ID!) {
  getSignInLog(id: $id) {
    id
    userPoolId
    userName
    company
    userTag
    clientId
    sub
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSignInLogQueryVariables,
  APITypes.GetSignInLogQuery
>;
export const listSignInLogs = /* GraphQL */ `query ListSignInLogs(
  $id: ID
  $filter: ModelSignInLogFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSignInLogs(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      userPoolId
      userName
      company
      userTag
      clientId
      sub
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSignInLogsQueryVariables,
  APITypes.ListSignInLogsQuery
>;
export const getCourseShowLog = /* GraphQL */ `query GetCourseShowLog($id: ID!) {
  getCourseShowLog(id: $id) {
    id
    companyId
    courseId
    course {
      id
      title
      productCode
      description
      thumbnail
      duration
      readable
      tags {
        nextToken
        __typename
      }
      clips {
        nextToken
        __typename
      }
      likes {
        courseId
        count
        timestamp
        createdAt
        updatedAt
        __typename
      }
      release
      timestamp
      createdAt
      updatedAt
      __typename
    }
    userName
    userTag
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCourseShowLogQueryVariables,
  APITypes.GetCourseShowLogQuery
>;
export const listCourseShowLogs = /* GraphQL */ `query ListCourseShowLogs(
  $id: ID
  $filter: ModelCourseShowLogFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCourseShowLogs(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      companyId
      courseId
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        release
        timestamp
        createdAt
        updatedAt
        __typename
      }
      userName
      userTag
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCourseShowLogsQueryVariables,
  APITypes.ListCourseShowLogsQuery
>;
export const listCourseShowLogByCompany = /* GraphQL */ `query ListCourseShowLogByCompany(
  $companyId: ID!
  $timestamp: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCourseShowLogFilterInput
  $limit: Int
  $nextToken: String
) {
  listCourseShowLogByCompany(
    companyId: $companyId
    timestamp: $timestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      courseId
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        release
        timestamp
        createdAt
        updatedAt
        __typename
      }
      userName
      userTag
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCourseShowLogByCompanyQueryVariables,
  APITypes.ListCourseShowLogByCompanyQuery
>;
export const getClipPlayLog = /* GraphQL */ `query GetClipPlayLog($id: ID!) {
  getClipPlayLog(id: $id) {
    id
    companyId
    courseId
    course {
      id
      title
      productCode
      description
      thumbnail
      duration
      readable
      tags {
        nextToken
        __typename
      }
      clips {
        nextToken
        __typename
      }
      likes {
        courseId
        count
        timestamp
        createdAt
        updatedAt
        __typename
      }
      release
      timestamp
      createdAt
      updatedAt
      __typename
    }
    clipId
    userName
    userTag
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetClipPlayLogQueryVariables,
  APITypes.GetClipPlayLogQuery
>;
export const listClipPlayLogs = /* GraphQL */ `query ListClipPlayLogs(
  $id: ID
  $filter: ModelClipPlayLogFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listClipPlayLogs(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      companyId
      courseId
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        release
        timestamp
        createdAt
        updatedAt
        __typename
      }
      clipId
      userName
      userTag
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClipPlayLogsQueryVariables,
  APITypes.ListClipPlayLogsQuery
>;
export const listClipPlayLogByCompany = /* GraphQL */ `query ListClipPlayLogByCompany(
  $companyId: String!
  $timestamp: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelClipPlayLogFilterInput
  $limit: Int
  $nextToken: String
) {
  listClipPlayLogByCompany(
    companyId: $companyId
    timestamp: $timestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      courseId
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        release
        timestamp
        createdAt
        updatedAt
        __typename
      }
      clipId
      userName
      userTag
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClipPlayLogByCompanyQueryVariables,
  APITypes.ListClipPlayLogByCompanyQuery
>;
export const getClipPlayLogTotal = /* GraphQL */ `query GetClipPlayLogTotal($clipId: ID!) {
  getClipPlayLogTotal(clipId: $clipId) {
    clipId
    clip {
      id
      title
      type
      url
      cover
      content
      order
      duration
      plays {
        clipId
        count
        timestamp
        createdAt
        updatedAt
        __typename
      }
      captions {
        nextToken
        __typename
      }
      courseId
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        release
        timestamp
        createdAt
        updatedAt
        __typename
      }
      timestamp
      createdAt
      updatedAt
      __typename
    }
    count
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetClipPlayLogTotalQueryVariables,
  APITypes.GetClipPlayLogTotalQuery
>;
export const listClipPlayLogTotals = /* GraphQL */ `query ListClipPlayLogTotals(
  $clipId: ID
  $filter: ModelClipPlayLogTotalFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listClipPlayLogTotals(
    clipId: $clipId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      clipId
      clip {
        id
        title
        type
        url
        cover
        content
        order
        duration
        courseId
        timestamp
        createdAt
        updatedAt
        __typename
      }
      count
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClipPlayLogTotalsQueryVariables,
  APITypes.ListClipPlayLogTotalsQuery
>;
export const getLikeLog = /* GraphQL */ `query GetLikeLog($id: ID!) {
  getLikeLog(id: $id) {
    id
    companyId
    courseId
    userName
    userTag
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLikeLogQueryVariables,
  APITypes.GetLikeLogQuery
>;
export const listLikeLogs = /* GraphQL */ `query ListLikeLogs(
  $id: ID
  $filter: ModelLikeLogFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listLikeLogs(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      companyId
      courseId
      userName
      userTag
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLikeLogsQueryVariables,
  APITypes.ListLikeLogsQuery
>;
export const listLikeLogByCompany = /* GraphQL */ `query ListLikeLogByCompany(
  $companyId: ID!
  $timestamp: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLikeLogFilterInput
  $limit: Int
  $nextToken: String
) {
  listLikeLogByCompany(
    companyId: $companyId
    timestamp: $timestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      courseId
      userName
      userTag
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLikeLogByCompanyQueryVariables,
  APITypes.ListLikeLogByCompanyQuery
>;
export const getLikeLogTotal = /* GraphQL */ `query GetLikeLogTotal($courseId: ID!) {
  getLikeLogTotal(courseId: $courseId) {
    courseId
    course {
      id
      title
      productCode
      description
      thumbnail
      duration
      readable
      tags {
        nextToken
        __typename
      }
      clips {
        nextToken
        __typename
      }
      likes {
        courseId
        count
        timestamp
        createdAt
        updatedAt
        __typename
      }
      release
      timestamp
      createdAt
      updatedAt
      __typename
    }
    count
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLikeLogTotalQueryVariables,
  APITypes.GetLikeLogTotalQuery
>;
export const listLikeLogTotals = /* GraphQL */ `query ListLikeLogTotals(
  $courseId: ID
  $filter: ModelLikeLogTotalFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listLikeLogTotals(
    courseId: $courseId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      courseId
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        release
        timestamp
        createdAt
        updatedAt
        __typename
      }
      count
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLikeLogTotalsQueryVariables,
  APITypes.ListLikeLogTotalsQuery
>;
export const getSsoEntry = /* GraphQL */ `query GetSsoEntry($id: ID!) {
  getSsoEntry(id: $id) {
    id
    company
    userName
    userTag
    to
    token
    ttl
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSsoEntryQueryVariables,
  APITypes.GetSsoEntryQuery
>;
export const listSsoEntries = /* GraphQL */ `query ListSsoEntries(
  $id: ID
  $filter: ModelSsoEntryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSsoEntries(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      company
      userName
      userTag
      to
      token
      ttl
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSsoEntriesQueryVariables,
  APITypes.ListSsoEntriesQuery
>;
export const getCnbcChannel = /* GraphQL */ `query GetCnbcChannel($id: ID!) {
  getCnbcChannel(id: $id) {
    id
    title
    description
    thumbnailPc
    thumbnailSp
    rss
    plans
    latestTimestamp
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCnbcChannelQueryVariables,
  APITypes.GetCnbcChannelQuery
>;
export const listCnbcChannels = /* GraphQL */ `query ListCnbcChannels(
  $id: ID
  $filter: ModelCnbcChannelFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCnbcChannels(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      title
      description
      thumbnailPc
      thumbnailSp
      rss
      plans
      latestTimestamp
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCnbcChannelsQueryVariables,
  APITypes.ListCnbcChannelsQuery
>;
export const getCnbcTitle = /* GraphQL */ `query GetCnbcTitle($id: ID!) {
  getCnbcTitle(id: $id) {
    id
    cnbcChannelId
    cnbcChannel {
      id
      title
      description
      thumbnailPc
      thumbnailSp
      rss
      plans
      latestTimestamp
      timestamp
      createdAt
      updatedAt
      __typename
    }
    title
    description
    author
    player
    copyright
    pubDate
    expirationDate
    thumbnail
    url
    pubDateTimestamp
    expirationDateTimestamp
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCnbcTitleQueryVariables,
  APITypes.GetCnbcTitleQuery
>;
export const listCnbcTitles = /* GraphQL */ `query ListCnbcTitles(
  $id: ID
  $filter: ModelCnbcTitleFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCnbcTitles(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      cnbcChannelId
      cnbcChannel {
        id
        title
        description
        thumbnailPc
        thumbnailSp
        rss
        plans
        latestTimestamp
        timestamp
        createdAt
        updatedAt
        __typename
      }
      title
      description
      author
      player
      copyright
      pubDate
      expirationDate
      thumbnail
      url
      pubDateTimestamp
      expirationDateTimestamp
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCnbcTitlesQueryVariables,
  APITypes.ListCnbcTitlesQuery
>;
export const listCnbcTitlesByChannel = /* GraphQL */ `query ListCnbcTitlesByChannel(
  $cnbcChannelId: ID!
  $expirationDateTimestamp: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCnbcTitleFilterInput
  $limit: Int
  $nextToken: String
) {
  listCnbcTitlesByChannel(
    cnbcChannelId: $cnbcChannelId
    expirationDateTimestamp: $expirationDateTimestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      cnbcChannelId
      cnbcChannel {
        id
        title
        description
        thumbnailPc
        thumbnailSp
        rss
        plans
        latestTimestamp
        timestamp
        createdAt
        updatedAt
        __typename
      }
      title
      description
      author
      player
      copyright
      pubDate
      expirationDate
      thumbnail
      url
      pubDateTimestamp
      expirationDateTimestamp
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCnbcTitlesByChannelQueryVariables,
  APITypes.ListCnbcTitlesByChannelQuery
>;
export const getCnbcCompanyViewLog = /* GraphQL */ `query GetCnbcCompanyViewLog($id: ID!) {
  getCnbcCompanyViewLog(id: $id) {
    id
    company
    cnbcChannelId
    cnbcChannel {
      id
      title
      description
      thumbnailPc
      thumbnailSp
      rss
      plans
      latestTimestamp
      timestamp
      createdAt
      updatedAt
      __typename
    }
    cnbcTitleId
    cnbcTitle {
      id
      cnbcChannelId
      cnbcChannel {
        id
        title
        description
        thumbnailPc
        thumbnailSp
        rss
        plans
        latestTimestamp
        timestamp
        createdAt
        updatedAt
        __typename
      }
      title
      description
      author
      player
      copyright
      pubDate
      expirationDate
      thumbnail
      url
      pubDateTimestamp
      expirationDateTimestamp
      timestamp
      createdAt
      updatedAt
      __typename
    }
    titleName
    pubDateTimestamp
    expirationDateTimestamp
    userName
    userTag
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCnbcCompanyViewLogQueryVariables,
  APITypes.GetCnbcCompanyViewLogQuery
>;
export const listCnbcCompanyViewLogs = /* GraphQL */ `query ListCnbcCompanyViewLogs(
  $id: ID
  $filter: ModelCnbcCompanyViewLogFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCnbcCompanyViewLogs(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      company
      cnbcChannelId
      cnbcChannel {
        id
        title
        description
        thumbnailPc
        thumbnailSp
        rss
        plans
        latestTimestamp
        timestamp
        createdAt
        updatedAt
        __typename
      }
      cnbcTitleId
      cnbcTitle {
        id
        cnbcChannelId
        title
        description
        author
        player
        copyright
        pubDate
        expirationDate
        thumbnail
        url
        pubDateTimestamp
        expirationDateTimestamp
        timestamp
        createdAt
        updatedAt
        __typename
      }
      titleName
      pubDateTimestamp
      expirationDateTimestamp
      userName
      userTag
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCnbcCompanyViewLogsQueryVariables,
  APITypes.ListCnbcCompanyViewLogsQuery
>;
export const listCnbcCompanyViewLogByCompany = /* GraphQL */ `query ListCnbcCompanyViewLogByCompany(
  $company: String!
  $timestamp: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCnbcCompanyViewLogFilterInput
  $limit: Int
  $nextToken: String
) {
  listCnbcCompanyViewLogByCompany(
    company: $company
    timestamp: $timestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      company
      cnbcChannelId
      cnbcChannel {
        id
        title
        description
        thumbnailPc
        thumbnailSp
        rss
        plans
        latestTimestamp
        timestamp
        createdAt
        updatedAt
        __typename
      }
      cnbcTitleId
      cnbcTitle {
        id
        cnbcChannelId
        title
        description
        author
        player
        copyright
        pubDate
        expirationDate
        thumbnail
        url
        pubDateTimestamp
        expirationDateTimestamp
        timestamp
        createdAt
        updatedAt
        __typename
      }
      titleName
      pubDateTimestamp
      expirationDateTimestamp
      userName
      userTag
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCnbcCompanyViewLogByCompanyQueryVariables,
  APITypes.ListCnbcCompanyViewLogByCompanyQuery
>;
export const getCourseTags = /* GraphQL */ `query GetCourseTags($id: ID!) {
  getCourseTags(id: $id) {
    id
    courseID
    tagID
    course {
      id
      title
      productCode
      description
      thumbnail
      duration
      readable
      tags {
        nextToken
        __typename
      }
      clips {
        nextToken
        __typename
      }
      likes {
        courseId
        count
        timestamp
        createdAt
        updatedAt
        __typename
      }
      release
      timestamp
      createdAt
      updatedAt
      __typename
    }
    tag {
      id
      label
      type
      order
      courses {
        nextToken
        __typename
      }
      timestamp
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCourseTagsQueryVariables,
  APITypes.GetCourseTagsQuery
>;
export const listCourseTags = /* GraphQL */ `query ListCourseTags(
  $filter: ModelCourseTagsFilterInput
  $limit: Int
  $nextToken: String
) {
  listCourseTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      courseID
      tagID
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        release
        timestamp
        createdAt
        updatedAt
        __typename
      }
      tag {
        id
        label
        type
        order
        timestamp
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCourseTagsQueryVariables,
  APITypes.ListCourseTagsQuery
>;
export const listLastShowRankingByTag = /* GraphQL */ `query ListLastShowRankingByTag(
  $companyId: String
  $tagType: String
  $limit: Int
) {
  listLastShowRankingByTag(
    companyId: $companyId
    tagType: $tagType
    limit: $limit
  ) {
    company
    count
    items {
      tagId
      tagLabel
      tagType
      companyId
      showCount
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLastShowRankingByTagQueryVariables,
  APITypes.ListLastShowRankingByTagQuery
>;
export const listRankingCourse = /* GraphQL */ `query ListRankingCourse(
  $companyId: String!
  $tagId: String
  $rankingType: String
  $recentRange: Int
  $limit: Int
) {
  listRankingCourse(
    companyId: $companyId
    tagId: $tagId
    rankingType: $rankingType
    recentRange: $recentRange
    limit: $limit
  ) {
    company
    count
    items {
      rankingType
      courseId
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        release
        timestamp
        createdAt
        updatedAt
        __typename
      }
      count
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRankingCourseQueryVariables,
  APITypes.ListRankingCourseQuery
>;
